import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSiteSettings } from "@/context/LanguageContext";
import { applyTheme } from "@/lib/theme";

/** Überträgt das im Admin gespeicherte Design (Farben, Schrift, Kopfzeile) als CSS-Variablen – nur außerhalb des Admin-Bereichs. */
export const ThemeApplier = () => {
  const { pathname } = useLocation();
  const site = useSiteSettings();
  useEffect(() => { applyTheme(site, !pathname.startsWith("/admin")); }, [site, pathname]);
  return null;
};
